import Link from "next/link";
import Image from "next/image";
import { useGlobalContext } from "@/src/context/GlobalContext";
import { ProfileImage, RightArrowBlackIcon } from "@/src/Asset";
import React from "react";

const CourseOrSpecializationItem = ({ item, type }: any) => {
  const isCourse = type === "course";
  const navbars = isCourse ? item?.course_navbars : item?.special_navbars;
  const url = isCourse ? item?.course_url : item?.specialization_url;
  const { setLeadFormData, setIsLeadFormOpen } = useGlobalContext();
  const handleOpen = (title: string, item: any) => {
    const courseData: any = [
      {
        id: item?.id,
        abbreviation: item?.abbreviation,
        course_name: item?.course_name,
      },
    ];
    setLeadFormData({
      source: `coursePage`,
      title: title ?? null,
      course: courseData ?? null,
    });
    setIsLeadFormOpen(true);
  };

  const itemsToDisplay = [
    {
      label: "Course Duration",
      value: item?.course_duration?.duration,
    },
    {
      label: "Total Colleges",
      value: item?.colleges?.count,
    },
    {
      label: "Avg. Fees",
      value: item?.average_fees?.average_fee,
    },
    {
      label: "Course Type",
      value: item?.courses_type?.course_type,
    },
    {
      label: "Qualifying Percentage",
      value: item?.qualifying_percentage?.percentage,
    },
    {
      label: "Course Level",
      value: item?.course_level?.course_level_name,
    },
  ];

  return (
    <div
      key={item?.id}
      className="border rounded bg-white shadow-md flex flex-col justify-between"
    >
      <div className="flex items-center justify-between bg-primary-light-gray rounded-t py-3 px-4">
        <div className="flex items-center gap-x-2">
          <Image
            src={item?.logo?.url || ProfileImage}
            alt={isCourse ? item?.course_name : item?.specialization_name}
            width={500}
            height={500}
            className="lg:w-11 lg:h-11 w-9 h-9 object-fill object-center"
          />
          <Link
            href={
              item?.page_data?.length > 0
                ? `/courses/${url}/${navbars[0]?.title
                    .replace(/\s+/g, "-")
                    .toLowerCase()}`
                : "#"
            }
          >
            <p className="text-sm lg:text-base font-medium lg:font-semibold hidden md:inline-block">
              {item?.course_name}
            </p>
            <p className="text-sm lg:text-base font-medium lg:font-semibold md:hidden">
              {item?.abbreviation}
            </p>
          </Link>
        </div>
        <div className="flex items-center gap-x-8">
          {navbars?.length > 0 && (
            <div className="inline-flex gap-x-2 lg:gap-x-3 h-fit">
              {navbars
                ?.slice(0, 3)
                ?.sort((a: any, b: any) => a.id - b.id)
                .map((navbar: any, index: number) => (
                  <div
                    key={navbar?.id}
                    className={`hover:underline flex items-center`}
                  >
                    <Link
                      href={
                        item?.page_data?.length > 0
                          ? `/courses/${url}/${navbar?.title
                              .replace(/\s+/g, "-")
                              .toLowerCase()}`
                          : "#"
                      }
                    >
                      <p className="lg:text-sm font-semibold text-xs text-primary underline underline-offset-1">
                        {navbar?.title}
                        <RightArrowBlackIcon className="-rotate-45 hidden md:inline-block scale-90" />
                      </p>
                    </Link>
                  </div>
                ))}
            </div>
          )}
          <button
            className="hidden md:block text-xs lg:text-sm text-white border border-black bg-primary rounded px-2 py-1.5 hover:scale-105 shadow-lg w-full lg:min-w-32 max-w-32"
            onClick={() => handleOpen(item?.abbreviation, item)}
          >
            Apply now
          </button>
        </div>
      </div>
      <div className="flex items-center gap-x-4 justify-center md:justify-between px-4 pb-3">
        <div className="hidden md:flex items-center">
          {itemsToDisplay
            .filter((item) => item.value && item.value !== 0)
            .map((item, index, filteredItems) => (
              <React.Fragment key={item?.label}>
                <div className="text-center">
                  <p className="text-xs lg:text-sm">{item?.label}</p>
                  <p className="text-xs lg:text-sm text-secondary-blue">
                    {item?.value}
                  </p>
                </div>
                {index < filteredItems?.length - 1 && (
                  <div className="w-[0.8px] h-8 bg-gray-400 mx-4"></div>
                )}
              </React.Fragment>
            ))}
        </div>

        <button
          className="text-xs md:hidden lg:text-sm text-white border border-black bg-primary rounded px-2 py-1.5 hover:scale-105 shadow-lg w-full lg:min-w-32 lg:max-w-32 max-w-52"
          onClick={() => handleOpen(item?.abbreviation, item)}
        >
          Apply now
        </button>

        {item?.colleges?.count > 0 && (
          <Link
            className="text-xs text-center lg:text-sm border border-primary bg-primary-blue/25 text-primary rounded px-2 py-1.5 hover:scale-105 shadow-lg w-full  lg:min-w-32 max-w-52 lg:max-w-32"
            href={
              isCourse
                ? `/${item?.course_url
                    .replace(/\s+/g, "-")
                    .toLowerCase()}-colleges-in-india`
                : `/${item?.specialization_url
                    .replace(/\s+/g, "-")
                    .toLowerCase()}-colleges-in-india`
            }
          >
            View Colleges
          </Link>
        )}
      </div>
    </div>
  );
};

export default CourseOrSpecializationItem;
